// Centralized business/brand constants
export const BRAND = {
  name: "ELA Traders",
  tagline: "Kerala Plantation Luxury",
  phone: "+91 77952 75838",
  phoneRaw: "+917795275838",
  whatsapp: "+91 77952 75838",
  whatsappRaw: "917795275838",
  email: "satishretnakaran82@gmail.com",
  address: {
    line1: "No. 42, Spice House, 18th Main",
    line2: "HSR Layout, Sector 3",
    city: "Bangalore, Karnataka 560102",
  },
  // Google Maps Embed
  mapEmbed:
    "https://www.google.com/maps?q=HSR+Layout+Bangalore&output=embed",
};

export const WHATSAPP_URL = `https://wa.me/${BRAND.whatsappRaw}?text=${encodeURIComponent(
  "Hello ELA Traders — I would like a wholesale cardamom quote."
)}`;
